// export configurations
let frontendProxy = ""
let consoleBaseUrl = ""

// set env
switch (process.env.VUE_APP_FIRE_ENV) {
  case "production":
    frontendProxy = "https://frontend-proxy.prod.connqt.ai"
    consoleBaseUrl = "https://console.rele.ai"
    break
  case "prod-eu":
    frontendProxy = "https://frontend-proxy.prod-eu.connqt.ai"
    consoleBaseUrl = "https://console.prod-eu.connqt.ai"
    break
  case "test":
    frontendProxy = "http://localhost:50007"
    consoleBaseUrl = "http://localhost:5000"
    break
  default:
    frontendProxy = "https://frontend-proxy.dev.connqt.ai"
    consoleBaseUrl = "https://console.dev.connqt.ai"
}

console.log("frontend proxy", frontendProxy)
console.log("vue app", process.env.VUE_APP_FIRE_ENV)
console.log("fire env", process.env.FIRE_ENV)

export { frontendProxy, consoleBaseUrl }
